import React, { useEffect, useState } from "react";
import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
  Form
} from "antd";
import useUsers from "../../hooks/useUsers";
import UserForm from "./UsersForm";
import search from "../../helpers/search";
import { userService } from "../../services/UserService";
import useStore from "../../hooks/useStores";
import { useForm } from "antd/lib/form/Form";
import useManufacturer from "../../hooks/useManufacturers";
import { user_default } from "./types";

const { Header, Content } = Layout;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email_id",
    key: "email",
  },
  {
    title: "Designation",
    dataIndex: "designation",
    key: "designation",
  },
  {
    title: "Country",
    dataIndex: "country_name",
    key: "country_name",
  },
];

const UsersPage: React.FC = function () {
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [form] = useForm();

  const [state, setState] = useState({
    visible: false,
    selected: user_default,
    isCreate: false,

    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [users, loadingUsers] = useUsers(state.pagination.current);
  const [usersToDisplay, setUsersToDisplay] = useState([]);

  const [stores, loadingStores] = useStore(1);
  const [manufacturers, loadingManufacturers] = useManufacturer(1);

  const onSearch = async (key: string) => {
    const { searchWord } = await form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "users",
      },
    ];

    const searchedData = await search(searchData, userService, key);
    setUsersToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  const onClose = async () => {
    const { searchWord } = await form.getFieldsValue();
    setState({
      ...state,
      visible: false,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "name",
          value: encodeURIComponent(searchWord),
          collection: "users",
        },
      ];

      const searchedData = await search(searchData, userService, "name");
      setUsersToDisplay(searchedData.data);
    } else {
      const searchedData = await userService.getAll(state.pagination.current);
      setUsersToDisplay(searchedData.data.users);
    }

    setSearching(false);
  };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await userService.getAll(pagination.current);
    setUsersToDisplay(data.data.users);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "users",
      },
    ];

    const data = await search(searchData, userService, "name");
    setUsersToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setUsersToDisplay(users.users);
    setState({
      ...state,

      pagination: {
        ...state.pagination,
        total: users.total,
      },
    });
  }, [users]);
  const loading = searching || loadingUsers;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Users (
              <span style={{ color: "#0a1e96" }}>
                {users && users.total ? users.total : 0}
              </span>
              )
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setIsCreate(true);
                setState({ ...state, isCreate: true, selected: user_default });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item
                    name="searchWord"
                  >
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      placeholder={"Search"}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setUsersToDisplay(users.users);
                              setState({
                                ...state,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: users.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              });
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      onClick={() => onSearch("name")}
                      style={{ width: 150 }}
                      htmlType="submit"
                    >
                      Search By Name
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>
        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      setState({
                        ...state,
                        selected: record,
                        isCreate: false,
                      });
                      setVisible(true);
                    },
                  };
                }}
                dataSource={usersToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                        selected: record,
                      });
                      setVisible(true);
                    },
                  };
                }}
                dataSource={usersToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <UserForm
        stores={stores}
        countries={[]}
        regions={[]}
        manufacturers={manufacturers}
        values={{
          ...state.selected,
        }}
        visible={visible}
        isChanged={false}
        setVisible={setVisible}
        isCreate={state.isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default UsersPage;
